

import { useEffect, useRef } from "react";
import { AiFillFileText } from "react-icons/ai";
import ReactMarkdown from "react-markdown";
//  Import the new component


type Source = {
  page_number: number;
  url: string;
};

type Result = {
  query: string;
  summary: string;
  source_count: number;
  sources: Source[];
};

type Props = {
  results: Result[]; // Changed from Result[] to Result
  onViewSource?: (url: string) => void; // Optional callback for viewing source
};

const ResultsCard = ({ results ,onViewSource}: Props) => {
  const topRef = useRef<HTMLDivElement | null>(null);

  // Auto-scroll when results change
  useEffect(() => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [results]);
  if (!results) return null;

  return (
    <div className="space-y-6 w-full mt-4 mb-30">
      {results.map((result, index) => (
        <div key={index}>
           <div ref={topRef} />
          <p className="text-md flex justify-end text-gray-800">
            <span className="text-gray-800 max-w-100 px-6 py-2 mb-2 rounded-2xl rounded-tr-none bg-gray-200 shadow-md">
              {result.query}
            </span>
          </p>

          <div className="bg-white shadow-md rounded-2xl p-6 transition hover:shadow-lg">
          
            {/* Header */}
            <div
            
            className="flex justify-between items-center mb-4">
              <h2 className="text-xl capitalize font-semibold text-gray-800">
                {result.query}
              </h2>
              <span className="text-sm text-gray-500">
                {result.source_count} Sources
              </span>
            </div>

            {/* Summary */}
            <div 
            className="text-gray-700 whitespace-pre-line">
              <ReactMarkdown>{result.summary}</ReactMarkdown>
            </div>

            {/* Sources */}
            {result.sources.length > 0 && (
              <div className="mt-4">
                <h3 className="text-sm font-medium text-gray-600 mb-2">
                  Sources:
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
                  {result.sources.map((source, i) => (
                    <button
                      key={i}
                    onClick={() => onViewSource && onViewSource(source.url)}
                   
                      className="flex items-center text-sm md:text-md text-center gap-0 lg:gap-2 px-2 py-1 bg-gray-50 rounded-2xl text-black hover:bg-gray-100 transition"
                    >
                      <AiFillFileText className="w-4 h-4" />
                      DOC {source.page_number}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
      
    </div>
  );
};

export default ResultsCard;
